(function() {
    'use strict';

    angular
        .module("showcaseApp")
        .component("styledActionsDropdown", {
            templateUrl: "app/components/styled-actions-dropdown/styled-actions-dropdown.html",
            controller: StyledActionsDropdownController,
            bindings: {
                name: "@",
                actions: "<",
                actionsArguments: '<',
                buttonStyle: '<',
                openUp: '<',
                drawerVisible: '=?',
                drawerTitle: '<',
            },
            transclude: true
        });

    /** @ngInject */
    function StyledActionsDropdownController($window, systemConstants) {
        var $ctrl = this;
        $ctrl.$onInit = init;

        $ctrl.isOpen = false;

        function init() {
            $ctrl.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;
            $ctrl.drawerVisible = $ctrl.drawerVisible ? $ctrl.drawerVisible : false;
            $ctrl.actions = $ctrl.actions ? $ctrl.actions : [];
            $ctrl.actionsArguments = $ctrl.actionsArguments ? $ctrl.actionsArguments : [];
            $ctrl.buttonStyle = $ctrl.buttonStyle ? $ctrl.buttonStyle : false;
            $ctrl.openUp = $ctrl.openUp ? $ctrl.openUp : false;
            $ctrl.drawerTitle = $ctrl.drawerTitle ? $ctrl.drawerTitle : '';
            $ctrl.hasBag = $ctrl.name.startsWith('bag');
            angular.element($window).on('resize', function() {
                $ctrl.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MAX_XS;
                if (!$ctrl.isMobile) {
                    $ctrl.closeDrawer();
                }
            });

            // Cleanup on destroy
            this.$onDestroy = function() {
                angular.element($window).off('resize');
            };
        }

        $ctrl.handleClick = function (method, actionsArguments) {
            $ctrl.isOpen = false;
            if (method !== undefined) {
                if (actionsArguments !== undefined && actionsArguments.constructor !== Array) {
                    actionsArguments = [actionsArguments];
                }
                method.apply(undefined, actionsArguments);
                $ctrl.closeDrawer();
            }
        }

        $ctrl.toggleDrawer = function () {
            $ctrl.drawerVisible = !$ctrl.drawerVisible;
        };

        $ctrl.closeDrawer = function () {
            $ctrl.drawerVisible = false;
        };
    }
})();
